import { styled } from '@mui/material'

import { theme } from 'styles/theme'

export const ContainerIcon = styled('div')(() => ({
  width: '35px',
  height: '35px',
  background: '#F8F8F8',
  borderRadius: '8px',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

export const Separator = styled('div')(() => ({
  width: '1fr',
  flexGrow: '1',
  borderTop: '0.5px dashed #CBCBCB',
  alignSelf: 'center',
  marginTop: '2px'
}))

// Mesma moldura dos accordions logo abaixo (borda, raio e faixa verde à
// esquerda), para o cabeçalho não parecer uma caixa estranha no meio deles.
export const RecurrenceContent = styled('div')(() => ({
  // Sem marginTop: o ModalContent da library já reserva 32px de padding, e a
  // soma dos dois abria um vão entre o cabeçalho do modal e este bloco.
  padding: 16,
  border: '1px solid #E8EBE8',
  borderLeft: '3px solid #01F7C2',
  borderRadius: '8px',
  backgroundColor: '#fff'
}))

export const Link = styled('a')(() => ({
  margin: 0,
  padding: 0,
  fontWeight: 600,
  color: '#231F20',
  cursor: 'pointer'
}))

export const AccordionWrapper = styled('a')(() => ({
  marginTop: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  [theme.breakpoints.up(450)]: {
    width: 'auto'
  }
}))
